export default "__VITE_ASSET__BcEMfDZq__"